import { useEffect } from 'react';

/**
 * Hook to protect images from being easily copied/downloaded
 * Note: This is not 100% foolproof but deters casual copying
 */
export const useImageProtection = () => {
  useEffect(() => {
    // Disable right-click on images
    const handleContextMenu = (e) => {
      if (e.target.tagName === 'IMG') {
        e.preventDefault();
        return false;
      }
    };

    // Disable drag on images
    const handleDragStart = (e) => {
      if (e.target.tagName === 'IMG') {
        e.preventDefault();
        return false;
      }
    };

    // Disable common save shortcuts when hovering over images
    const handleKeyDown = (e) => {
      // Disable Ctrl+S (Save)
      if ((e.ctrlKey || e.metaKey) && e.key === 's') {
        e.preventDefault();
        return false;
      }
      // Disable Ctrl+Shift+I (Developer tools - optional, can be annoying)
      // Disable Ctrl+U (View source - optional)
    };

    // Add event listeners
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('dragstart', handleDragStart);
    document.addEventListener('keydown', handleKeyDown);

    // Cleanup
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('dragstart', handleDragStart);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
};

/**
 * Protected Image Component
 * Wraps an image with protection against easy copying
 */
export const ProtectedImage = ({ 
  src, 
  alt, 
  className = '', 
  ...props 
}) => {
  return (
    <div className={`protected-image-wrapper ${className}`} style={{ position: 'relative', display: 'inline-block' }}>
      <img
        src={src}
        alt={alt}
        loading="lazy"
        decoding="async"
        draggable={false}
        onContextMenu={(e) => e.preventDefault()}
        onDragStart={(e) => e.preventDefault()}
        style={{ 
          pointerEvents: 'none',
          userSelect: 'none',
          WebkitUserSelect: 'none',
          MozUserSelect: 'none',
          msUserSelect: 'none',
        }}
        {...props}
      />
      {/* Transparent overlay to prevent direct image interaction */}
      <div 
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'transparent',
          zIndex: 1,
        }}
        onContextMenu={(e) => e.preventDefault()}
      />
    </div>
  );
};
